import React from 'react';
import { motion } from 'framer-motion';
export function CycleSection() {
  const cycleSteps = ['Vas a tener intimidad', 'Piensas: "¿y si fallo?"', 'Tu cuerpo entra en tensión', 'Te aceleras o pierdes control', 'Fallas o no respondes como quieres', 'Te frustras', 'Refuerzas el problema'];
  return <section className="relative w-full bg-black py-10 md:py-14 overflow-hidden" data-id="element-104">
      <div className="absolute inset-0 z-0" data-id="element-105">
        <div className="absolute top-1/3 right-0 w-[500px] h-[500px] rounded-full bg-red-900/20 blur-[120px]" data-id="element-106" />
      </div>

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-px bg-gradient-to-r from-transparent via-red-600 to-transparent z-20" data-id="element-107" />

      <div className="relative z-20 max-w-4xl mx-auto px-6" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-109">
          <h2 className="font-display text-4xl md:text-5xl uppercase mb-10 text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-110">
            <span className="text-red-500 drop-shadow-[0_0_15px_rgba(220,38,38,0.8)]" data-id="element-111">
              🔁
            </span>{' '}
            El ciclo que nadie te explica
          </h2>

          {/* Compact grid cycle */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-10" data-id="element-112">
            {cycleSteps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} className="flex items-center gap-4 bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/30 rounded-lg p-4" data-id="element-113">
                <div className="flex-shrink-0 w-9 h-9 rounded-full bg-gradient-to-b from-red-600 to-red-800 flex items-center justify-center font-bold text-white text-sm shadow-[0_0_12px_rgba(220,38,38,0.5)] border border-red-400/30" data-id="element-114">
                  {index + 1}
                </div>
                <p className="text-sm md:text-base text-gray-200 font-medium" data-id="element-115">
                  {step}
                </p>
              </motion.div>)}
          </div>

          <p className="text-center text-lg md:text-xl text-gray-500 italic" data-id="element-116">
            Y lo repites. Otra vez. Y otra.
          </p>
        </motion.div>
      </div>
    </section>;
}